import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import UseCaseDetailsFrame from 'src/components/use-case-details-frame'
import PillButton from 'src/components/pill-button'
import TextButton from 'src/components/text-button'
import BrowserContainer from 'src/components/browser-container'
import TapAnimation from 'src/components/tap-animation'
import content1SrcA from 'src/assets/use-case-4-content-1-a.png'
import content1SrcB from 'src/assets/use-case-4-content-1-b.png'
import content2Src from 'src/assets/use-case-4-content-2.png'
import content3Src from 'src/assets/use-case-4-content-3.png'
import content4Src from 'src/assets/use-case-4-content-4.png'
import content5Src from 'src/assets/use-case-4-content-5.png'

export class UseCase4Frame1 extends Component {
  static propTypes = {
    className: PropTypes.string,
    useCase: PropTypes.object.isRequired,
    back: PropTypes.func.isRequired,
    switchDelay: PropTypes.number,
    tapDelay: PropTypes.number,
  }

  static defaultProps = {
    className: '',
    switchDelay: 2000,
    tapDelay: 500,
  }

  state = {
    contentId: 'content-1',
    switchTimer: null,
    forceIndex: null,
    shouldTapA: false,
    shouldTapB: false,
    shouldTap3: false,
    onTapComplete: () => {},
  }

  get className() {
    const { className } = this.props
    return c('im-use-case-4-frame-1', className)
  }

  switchContent = () => {
    this.setState({ contentId: 'content-5' })
  }

  render() {
    const { className, switchContent } = this
    const { useCase, back, switchDelay, tapDelay } = this.props
    const { contentId, forceIndex, shouldTapA, shouldTapB, shouldTap3, onTapComplete } = this.state
    const { content1, content2, content3, content4, content5 } = useCase
    return (
      <UseCaseDetailsFrame className={className} back={back} useCase={useCase}>
        <section className={c('content content-1', contentId === 'content-1' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h3>{content1.copy1}</h3>
              <h2>{content1.copy2}</h2>
            </section>
            <section className="pill-buttons">
              <PillButton
                onClick={() => {
                  this.setState({ forceIndex: 0 })
                  setTimeout(() => {
                    this.setState({
                      shouldTapA: true,
                      shouldTapB: false,
                      onTapComplete: () => {
                        this.setState({
                          contentId: 'content-3',
                          forceIndex: null,
                          shouldTapA: false,
                          shouldTapB: false,
                        })
                      },
                    })
                  }, tapDelay)
                }}>
                {content1.button1}
              </PillButton>
              <PillButton
                onClick={() => {
                  this.setState({ forceIndex: 1 })
                  setTimeout(() => {
                    this.setState({
                      shouldTapA: false,
                      shouldTapB: true,
                      onTapComplete: () => {
                        this.setState({
                          contentId: 'content-2',
                          forceIndex: null,
                          shouldTapA: false,
                          shouldTapB: false,
                        })
                      },
                    })
                  }, tapDelay)
                }}>
                {content1.button2}
              </PillButton>
            </section>
          </section>
          <section className="device-container">
            <BrowserContainer src={[content1SrcA, content1SrcB]} forceIndex={forceIndex}>
              <TapAnimation className="tap-a" shouldTap={shouldTapA} onTapComplete={onTapComplete} />
              <TapAnimation className="tap-b" shouldTap={shouldTapB} onTapComplete={onTapComplete} />
            </BrowserContainer>
          </section>
        </section>
        <section className={c('content content-2', contentId === 'content-2' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content2.copy1}</h2>
              <p>{content2.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content2.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <BrowserContainer src={content2Src} />
          </section>
        </section>
        <section className={c('content content-3', contentId === 'content-3' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content3.copy1}</h2>
            </section>
            <section className="pill-buttons with-text-buttons">
              <PillButton
                onClick={() => {
                  setTimeout(() => {
                    this.setState({
                      shouldTap3: true,
                      onTapComplete: () => {
                        const timer = setTimeout(switchContent, switchDelay)
                        this.setState({ shouldTap3: false, contentId: 'content-4', switchTimer: timer })
                      },
                    })
                  }, tapDelay)
                }}>
                {content3.button1}
              </PillButton>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content3.button2}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <BrowserContainer src={content3Src}>
              <TapAnimation className="tap-3" shouldTap={shouldTap3} onTapComplete={onTapComplete} />
            </BrowserContainer>
          </section>
        </section>
        <section className={c('content content-4', contentId === 'content-4' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content4.copy1}</h2>
              <p>{content4.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton
                onClick={() => {
                  clearTimeout(this.state.switchTimer)
                  this.setState({ contentId: 'content-1' })
                }}>
                {content4.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <BrowserContainer src={content4Src} />
          </section>
        </section>
        <section className={c('content content-5', contentId === 'content-5' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content5.copy1}</h2>
              <p>{content5.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content5.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <BrowserContainer src={content5Src} />
          </section>
        </section>
      </UseCaseDetailsFrame>
    )
  }
}

export default UseCase4Frame1
